var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { VueType, Component } from '../core';
import { ISubscribeState } from '../../store/SubscribeState';
import SubscribeItem from './SubscribeItem';
import './subscribe.style.scss';
import { domEvent } from '../../../common/scroll';
import Empty from '../components/Empty';
let Subscribe = class Subscribe extends VueType {
    get isHasData() {
        return this.state.subList.some(item => !!item.isSub);
    }
    created() {
        this.state.loadSubList();
    }
    mounted() {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const self = this;
        domEvent.bottom.on(this.loadMore);
        $(this.$el).on('click', '[data-uin]', function () {
            const $el = $(this);
            const uin = $el.data('uin');
            // data有缓存
            const isCreator = Number($el.attr('data-iscreator')) === 1;
            const isSub = Number($el.attr('data-sub')) === 1;
            if (isCreator) {
                self.state.subCreator(String(uin), !isSub);
            }
            else if (uin) {
                self.state.sub(uin, !isSub);
            }
        });
    }
    activated() {
        domEvent.bottom.on(this.loadMore);
    }
    loadMore() {
        this.state.loadSubList();
    }
    deactivated() {
        domEvent.bottom.off(this.loadMore);
    }
    beforeDestroy() {
        domEvent.bottom.off(this.loadMore);
    }
    render() {
        let dom = null;
        if (this.isHasData) {
            dom = (<div>
                    {this.state.subList.map(sub => <SubscribeItem sub={sub} key={sub.uin}></SubscribeItem>)}
                </div>);
        }
        else {
            dom = <Empty title="你暂时还没有订阅哦~"></Empty>;
        }
        return <div>
            {this.state.isHasSub && dom}
        </div>;
    }
};
__decorate([
    ISubscribeState
], Subscribe.prototype, "state", void 0);
Subscribe = __decorate([
    Component
], Subscribe);
export default Subscribe;
